import { getCommonParams } from "../services/analyticsService";

const defaultEventsList = ["adtech_vc_impression", "adtech_vc_click", "adtech_vc_close"];
const getVideoCommerceParams = data => {
  const commonParams = getCommonParams();
  const adTechParameters = {
    content_id: data.content_id,
    object_id: data.object_id,
    frame_time: data.frame_time,
    obj_gender: data.obj_gender,
    obj_age_category: data.obj_age_category,
    product_id: data.product_id,
    title: data.title,
    category_name: data.category_name,
    age: data.age,
    gender: data.gender,
    brand: data.brand,
    link: data.link
  };
  return {
    ...adTechParameters,
    ...commonParams
  };
};

export function VideoCommerceParams(action, data) {
  let params = null;
  if (defaultEventsList.includes(action)) {
    params = getVideoCommerceParams(data);
  }
  return params;
}
